import React, { Fragment, useState, useEffect } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import clsx from 'clsx';
import numeral from 'numeral';
import { toInteger } from 'lodash';

import Pager from 'src/utils/Pager';
import agm from '../../services/agm'


import {
    Tooltip,
    Icon,
    Avatar,
    Box,
    InputLabel,
    Select,
    MenuItem,
    makeStyles,
    Grid,
    Card,
    Table,
    Radio,
    TablePagination,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TableContainer,
    DialogTitle,
    Divider,
    DialogContent,
    Dialog,
    colors,
    Typography,
    Button,
    TextField,
    InputAdornment,
    SvgIcon,
    FormControl,
    CardContent
} from '@material-ui/core';

import { Search as SearchIcon } from 'react-feather';
import { IoMdCart } from "react-icons/io";

var Item = IoMdCart;

const useStyles = makeStyles((theme) => ({
    root: {
    },
    avatar: {
        marginRight: theme.spacing(2),
        backgroundColor: colors.grey[200]
    },
    container: {
        maxHeight: 415,
        minHeight: 415
    }
}));

const visions = [
    { id: 2, name: 'Produtos pelo nome', refine: 2, label: 'Nome do produto contendo', history: 0, columns: [] },
    { id: 1, name: 'Produtos pelo código', refine: 1, label: 'Código do produto', history: 0, columns: [] }
];

const defaultState = {
    loaded: false,
    pages: 1,
    page: 1,
    count: 0,
    rows: []
}

const defaultFilter = {
    pagina: 0,
    registros: 10,
    palavrachave: '',
    visao: visions[0],
    ativo: true
}

const Find = ({ open, closeFind, selectProduct, values }) => {

    const classes = useStyles();

    const [filter, setFilter] = useState(defaultFilter);
    const [keyword, setKeyword] = useState('');
    const [query, setQuery] = useState(visions[0]);
    const [selected, setSelected] = useState(null);
    const [page, setPage] = useState(0);
    const [rows, setRows] = useState(10);
    const [resultset, setResultset] = useState(defaultState);

    const handleSelect = (item) => () => {
        setSelected(item);
    };

    const changeQuery = (event) => {
        setQuery(event.target.value);
        setPage(0);
        changeFilter(event.target.value, keyword, page, rows);
    }

    const changeKeyword = (event) => {
        setKeyword(event.target.value);
        setPage(0);
        changeFilter(query, event.target.value, page, rows);
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        changeFilter(query, keyword, newPage, rows);
    };

    const handleChangeRowsPerPage = (event) => {
        var rowsPerPage = parseInt(event.target.value, 10);
        setRows(rowsPerPage);
        setPage(0);
        changeFilter(query, keyword, page, rowsPerPage);
    };

    const refreshItems = () => {
        agm.post('/produtos/historico', { filtro: filter }, {
        }).then((response) => {
            if (!response.data.error) {
                setResultset({
                    loaded: true,
                    pages: toInteger((response.data.count / filter.registros)) + 1,
                    page: filter.pagina,
                    count: response.data.count,
                    rows: response.data.rows
                });
            } else {
                setResultset(defaultState);
            }
        }).catch((error) => {
            console.error(error);
        })
    }

    useEffect(() => {
        if (!resultset.loaded) {
            setSelected(null);
            refreshItems();
        }
        return
    }, []);

    const changeFilter = (view, keyword, page, rows) => {
        const value = {
            pagina: page,
            registros: rows,
            palavrachave: keyword,
            visao: view,
            ativo: true
        }
        setFilter(value);
        agm.post('/produtos/historico', { filtro: value }, {
        }).then((response) => {
            if (!response.data.error) {
                setResultset({
                    loaded: true,
                    pages: toInteger((response.data.count / value.registros)) + 1,
                    page: value.pagina,
                    count: response.data.count,
                    rows: response.data.rows
                });
            } else {
                setResultset(defaultState);
            }
        }).catch((error) => {
            console.error(error);
        })
    }


    return (
        <Fragment>

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="xl" fullWidth >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Buscar por Produto
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Box >
                        <Card>
                            <CardContent>

                                <Grid
                                    container
                                    spacing={2}
                                    xs="auto"
                                >

                                    <Grid item
                                        md={12}
                                        xs={12}
                                    >

                                        <Grid container spacing={1}>

                                            <Grid item
                                                md={3}
                                                xs={12}>

                                                <FormControl variant="outlined" margin="none" fullWidth>
                                                    <InputLabel shrink htmlFor="query">Pesquisa</InputLabel>
                                                    <Select notched
                                                        required={true}
                                                        fullWidth={true}
                                                        label="Pesquisa"
                                                        variant="outlined"
                                                        id="query"
                                                        name="query"
                                                        value={query}
                                                        onChange={changeQuery}
                                                        inputProps={{
                                                            name: 'query',
                                                            id: 'query',
                                                        }}
                                                    >
                                                        {visions.map((view) => (
                                                            <MenuItem key={view.id} value={view}>{view.name}</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>
                                            </Grid>

                                            <Grid item
                                                md={6}
                                                xs={12}
                                            >
                                                <TextField
                                                    fullWidth
                                                    margin="none"
                                                    disabled={!query.refine}
                                                    onChange={changeKeyword}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <SvgIcon
                                                                    fontSize="small"
                                                                    color="action"
                                                                >
                                                                    <SearchIcon />
                                                                </SvgIcon>
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                    placeholder={"Refinar pesquisa por, " + query.label}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                        </Grid>

                                    </Grid>

                                    <Grid item
                                        md={12}
                                        xs={12}
                                    >
                                        <Grid container
                                            fullWidth
                                            direction="row"
                                            justify="flex-start"
                                            alignItems="flex-start"
                                        >

                                            <Grid item
                                                md="auto"
                                                xs="auto"
                                            >

                                                <TablePagination
                                                    component="div"
                                                    className={classes.pager}
                                                    page={page}
                                                    rowsPerPage={rows}
                                                    count={resultset.count}
                                                    labelRowsPerPage="Linhas por página"
                                                    labelDisplayedRows={({ from, to, count }) => `Encontrados: ${count}, Apresentando de: ${from} a ${to}`}
                                                    onChangePage={handleChangePage}
                                                    onChangeRowsPerPage={handleChangeRowsPerPage}
                                                    ActionsComponent={Pager}
                                                    SelectProps={{
                                                        inputProps: { 'aria-label': 'Linhas por página' },
                                                        native: false
                                                    }}
                                                />

                                            </Grid>

                                        </Grid>

                                    </Grid>

                                </Grid>
                            </CardContent>
                        </Card>

                        <br></br>

                        <Card>
                            <CardContent>


                                <Grid
                                    container
                                    spacing={2}
                                    xs="auto"
                                >
                                    <Grid item
                                        md={12}
                                        xs={12}
                                    >

                                        <TableContainer component={PerfectScrollbar} className={classes.container}>

                                            <Table stickyHeader size="small" aria-label="a dense table" >
                                                <TableHead>
                                                    <TableRow>

                                                        <TableCell>
                                                            Código
                                                        </TableCell>

                                                        <TableCell>
                                                            Nome
                                                        </TableCell>

                                                        <TableCell>
                                                            Tipo
                                                        </TableCell>

                                                        <TableCell>
                                                            Categoria
                                                        </TableCell>

                                                        <TableCell>
                                                            LPU
                                                        </TableCell>

                                                        <TableCell>
                                                            Valor Custo
                                                        </TableCell>

                                                        <TableCell>
                                                            BDI
                                                        </TableCell>

                                                        <TableCell>
                                                            Valor Material
                                                        </TableCell>

                                                        <TableCell>
                                                            Estoque
                                                        </TableCell>

                                                        <TableCell>
                                                            Valor Mão Obra
                                                        </TableCell>

                                                        <TableCell>

                                                        </TableCell>

                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {resultset.rows.map((item) => (
                                                        <TableRow
                                                            hover
                                                            key={item.id}
                                                        >
                                                            <TableCell width={10}>
                                                                <Box
                                                                    alignItems="center"
                                                                    display="flex"
                                                                >
                                                                    <Avatar
                                                                        className={classes.avatar}
                                                                    >
                                                                        {<Icon component={Item} style={{ color: colors.cyan[500] }} ></Icon>}
                                                                    </Avatar>
                                                                    {item.codigo}
                                                                </Box>
                                                            </TableCell>

                                                            <TableCell>
                                                                {item.nome}
                                                            </TableCell>

                                                            <TableCell>
                                                                {(item.tipo) ? item.tipo.nome : "Não Informado"}
                                                            </TableCell>

                                                            <TableCell >
                                                                {(item.aplicacao) ? item.aplicacao.nome : "Não Informado"}
                                                            </TableCell>

                                                            <TableCell >
                                                                {(item.lpu) ? item.lpu.nome : "Não Informado"}
                                                            </TableCell>

                                                            <TableCell align="right">
                                                                {(item.custo) ? numeral(item.custo).format('0.00').replace('.', ',') : '0,00'}
                                                            </TableCell>

                                                            <TableCell align="right">
                                                                {(item.bdi) ? numeral(item.bdi).format('0.00').replace('.', ',') : '0,00'}
                                                            </TableCell>

                                                            <TableCell align="right">
                                                                {(item.valor) ? numeral(item.valor).format('0.00').replace('.', ',') : '0,00'}
                                                            </TableCell>

                                                            <TableCell align="right">
                                                                {(item.estoque) ? numeral(item.estoque).format('0.00').replace('.', ',') : '0,00'}
                                                            </TableCell>

                                                            <TableCell align="right">
                                                                {(item.instalacao) ? numeral(item.instalacao).format('0.00').replace('.', ',') : '0,00'}
                                                            </TableCell>

                                                            <TableCell>
                                                                <Tooltip title="Selecionar operação como padrão">
                                                                    <Radio id={item.id}
                                                                        value={item.id}
                                                                        checked={(selected) ? selected.id === item.id : false}
                                                                        onChange={handleSelect(item)} />
                                                                </Tooltip>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                    }

                                                    {(resultset.rows.length == 0) ? (
                                                        <TableRow  >
                                                            <TableCell colSpan={14} align="center" >
                                                                Nenhum Produto Foi Encontrada.
                                                            </TableCell>
                                                        </TableRow>
                                                    ) : ('')}

                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                    </Grid>

                                </Grid>
                            </CardContent>
                        </Card>

                    </Box>

                    <Divider />

                    <Box my={1}>
                        <Grid container
                            direction="row"
                            justify="flex-end"
                            alignItems="center"
                            spacing={1}  >
                            <Grid item >
                                <Button
                                    color="secondary"
                                    size="small"
                                    variant="contained"
                                    onClick={() => { selectProduct(values, selected) }}>
                                    Adicionar
                                </Button>
                            </Grid>
                            <Grid item >
                                <Button
                                    color="secondary"
                                    size="small"
                                    variant="contained"
                                    onClick={() => { closeFind() }}>
                                    Cancelar
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>

                </DialogContent>

            </Dialog>

        </Fragment >
    );
};

export default Find;
